/**
 * This file is maintained by Stencil, do not directly modify this file
 */
import {AmplitudeProjectSelection, initializeAmplitude} from '@udemy-v2/amplitude';
import {CommonData} from '@udemy-v2/common-data';
import {setSentryContext} from '@/lib/sentry';

// Add import statements for custom third-party vendor integrations below
// <<Stencil::Block(customImports)>>
// <</Stencil::Block>>

/**
 * Initializes third-party vendors with common application data
 * Currently sets up Sentry context with the provided common data
 *
 * @param fullCommonData - The complete common data object containing app context
 */
export function initializeVendors(fullCommonData: CommonData, locale: string): void {
    try {
        // Set Sentry context with the full common data for better error tracking
        setSentryContext(fullCommonData);
    } catch (error) {
        // Log error but don't break the application
        console.error('Failed to initialize Sentry context:', error);
    }

    try {
        const formattedLocale = locale.replace('_', '-');
        // Initialize Amplitude Guides & Surveys
        initializeAmplitude(fullCommonData, {
            locale: formattedLocale,
            projectSelection: AmplitudeProjectSelection.ONLY_UNSAMPLED,
        });
    } catch (error) {
        // Log error but don't break the application
        console.error('Failed to initialize Amplitude Guides & Surveys:', error);
    }

    // Initialize custom vendors here
    // <<Stencil::Block(initializeVendors)>>
    // <</Stencil::Block>>
}
